import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { setExceptionHandler, getLoaderBtn } from '@app/store/actions';
import { ModalActionsComponent, PasslyTextField } from '@app/components';
import { FormControl } from '@material-ui/core';
import { genericErrorToast } from '@app/helpers';
import { FormMode } from '@app/helpers/enums';
import { vaultFoldersService } from '@app/services';

export interface IReceivedData {
    formMode: FormMode;
    vaultId: string;
    folderName?: string;
    folderId?: string;
    dialogOpen: Function;
    handleRefresh: Function;
}

export const AddEditFolderDialog = (props: IReceivedData) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [folderName, setFolderName] = useState(props.folderName);
    const [folderNameInvalid, setFolderNameInvalid] = useState(false);

    useEffect(() => {
        dispatch(setExceptionHandler(true));
    }, []);

    const onFormChange = (e: any) => {
        const { name, value } = e.target;

        switch (name) {
            case 'folderName':
                setFolderName(value);
                break;
            default:
                break;
        }
    };

    const onFolderNameChange = (e: any) => {
        setErrorMessage('');
        onFormChange(e);

        const folderChosen = e.target.value.trim();

        if (folderChosen === '') {
            setFolderNameInvalid(true);
        } else {
            setFolderNameInvalid(false);
        }
    };

    const handleCancel = () => {
        dispatch(getLoaderBtn(false));
        props.dialogOpen(false);
    };

    const handleSaveBtn = (e: any) => {
        e.preventDefault();
        dispatch(getLoaderBtn(true));

        let jsonObject: any = {};

        jsonObject.DisplayName = folderName;
        jsonObject.VaultId = props.vaultId;

        vaultFoldersService.isVaultFolderNameAvailable(jsonObject, props.vaultId, handleSuccessVaultNameValid, genericErrorToast);
    };

    const handleSuccessVaultNameValid = (response: any) => {
        const result: boolean = response.data.value;

        if (result) {
            // save folder name
            let jsonObject: any = {};

            jsonObject.DisplayName = folderName;
            jsonObject.VaultId = props.vaultId;

            if (props.formMode === FormMode.Edit) {
                jsonObject.Id = props.folderId;

                vaultFoldersService.updateVaultFolder(jsonObject, props.vaultId, handleSuccess, genericErrorToast);
            } else {
                vaultFoldersService.addVaultFolder(jsonObject, props.vaultId, handleSuccess, genericErrorToast);
            }
        } else {
            dispatch(getLoaderBtn(false));
            setErrorMessage(translation('INVALID_TAKEN_FOLDER_NAME'));
        }
    };

    const handleSuccess = () => {
        dispatch(getLoaderBtn(false));
        props.dialogOpen(false);
        props.handleRefresh(true);
    };

    return (
        <>
            <form method='post' className='modal__form' tabIndex={0} onKeyPress={(e: React.KeyboardEvent<HTMLFormElement>) => {
                if (e.key === 'Enter' && !folderNameInvalid && folderName !== '') {
                    e.preventDefault();
                    handleSaveBtn(e);
                }
            }}>
                <div className='modal__body--row'>
                        <PasslyTextField
                            name='folderName'
                            label={'FOLDER_NAME'}
                            value={folderName}
                            onChange={onFolderNameChange}
                            id='folderName-input'
                            inputProps={{ maxLength: 100 }}
                            autoFocus
                            required
                            error={folderNameInvalid}
                            helperText={folderNameInvalid && translation('REQUIRED_FIELD')}
                            fullWidth
                        />
                </div>
            </form>

            {errorMessage && <div className='modal__error'>{errorMessage}</div>}

            <ModalActionsComponent
                primaryBtn={props.formMode === FormMode.Add ? translation('ADD_VAULT_FOLDER') : translation('SAVE')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleSaveBtn}
                onClickSecondary={handleCancel}
                disabled={folderNameInvalid}
                id='addVaultFolder'
            />
        </>
    );
};
